import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";
import { current } from "@reduxjs/toolkit";

const COLORS = {
  main: "#13816F",
  pastel1: "#CFF0EA",
  pastel2: "#E3F7F3",
};

const fmtMoney = (v) =>
  typeof v === "number"
    ? v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

export default function AgencyFeeDetail({
  title = "",
  info = {},
  forma = {},
  report_tz = "",
  timezones = {},
  formatNumber,
  onGeneratePdf,
  onGenerateCsv,
  onBack,
}) {
  // Totales generales
  const total_total = {
    net: 0,
    policy: 0,
    iva: 0,
    total: 0,
    agency: 0,
    collected: 0,
  };

  let currentPaymentType = "";

  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      <form id="report_form">
        {forma &&
          Object.entries(forma).map(([field_name, field_value]) => (
            <input
              key={field_name}
              type="hidden"
              name={field_name}
              value={field_value}
              readOnly
            />
          ))}
      </form>
      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "#fff", borderRadius: 8 }}
            >
              {/* Header */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">
                    {report_tz
                      ? `${timezones?.[report_tz]} - ${report_tz.toUpperCase()}`
                      : ""}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(12, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(12, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              {/* Date + Company */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {new Date().toLocaleString()}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>
              {/* Main Table */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={10}
                        style={{
                          background: COLORS.main,
                          color: "#fff",
                          fontWeight: 700,
                        }}
                      >
                        {info.agency?.code} {info.agency?.name}
                      </TableCell>
                    </TableRow>
                    {info.details &&
                      Object.entries(info.details).map(
                        ([date, methods], idxDate) => {
                          let total = {};
                          return (
                            <React.Fragment key={date}>
                              <TableRow>
                                <TableCell
                                  colSpan={10}
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                    fontWeight: 700,
                                  }}
                                >
                                  Issue Date:{" "}
                                  {new Date(date).toLocaleDateString()}
                                </TableCell>
                              </TableRow>
                              {Object.entries(methods).map(
                                (method, idxMethod) => {
                                  let subtotal = {
                                    net: 0,
                                    policy: 0,
                                    iva: 0,
                                    total: 0,
                                    agency: 0,
                                    collected: 0,
                                  };
                                  return (
                                    <React.Fragment key={idxMethod}>
                                      <TableRow>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          Policy Number
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          Customer Name
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          Net Premium
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          Policy Fee
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          IVA
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          Total Premium
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          Agency Fee
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          Total Collected
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          Payment Type
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background: COLORS.pastel1,
                                            color: "#000",
                                          }}
                                        >
                                          Create Date
                                        </TableCell>
                                      </TableRow>
                                      {Object.entries(method[1]).map(
                                        (row, idxRow) => {
                                          row = row[1];
                                          currentPaymentType = row.payment_name;
                                          if (!total[row.payment_name]) {
                                            total[row.payment_name] = {
                                              net: 0,
                                              policy: 0,
                                              iva: 0,
                                              total: 0,
                                              agency: 0,
                                              collected: 0,
                                            };
                                          }
                                          total[
                                            row.payment_name
                                          ].net += parseFloat(
                                            row.revised_net_premium
                                          );
                                          total[
                                            row.payment_name
                                          ].iva += parseFloat(row.iva);
                                          total[
                                            row.payment_name
                                          ].total += parseFloat(row.total);
                                          total[
                                            row.payment_name
                                          ].policy += parseFloat(
                                            row.policy_fee
                                          );
                                          total[
                                            row.payment_name
                                          ].agency += parseFloat(
                                            row.agency_fee
                                          );
                                          total[row.payment_name].collected +=
                                            parseFloat(row.total) +
                                            parseFloat(row.agency_fee);

                                          total_total.net += parseFloat(
                                            row.revised_net_premium
                                          );
                                          total_total.iva += parseFloat(
                                            row.iva
                                          );
                                          total_total.total += parseFloat(
                                            row.total
                                          );
                                          total_total.policy += parseFloat(
                                            row.policy_fee
                                          );
                                          total_total.agency += parseFloat(
                                            row.agency_fee
                                          );
                                          total_total.collected +=
                                            parseFloat(row.total) +
                                            parseFloat(row.agency_fee);

                                          subtotal.net += parseFloat(
                                            row.revised_net_premium
                                          );
                                          subtotal.policy += parseFloat(
                                            row.policy_fee
                                          );
                                          subtotal.iva += parseFloat(row.iva);
                                          subtotal.total += parseFloat(
                                            row.total
                                          );
                                          subtotal.agency += parseFloat(
                                            row.agency_fee
                                          );
                                          subtotal.collected +=
                                            parseFloat(row.total) +
                                            parseFloat(row.agency_fee);

                                          return (
                                            <TableRow
                                              key={idxRow}
                                              className="odd gradeX"
                                            >
                                              <TableCell>
                                                {row.policy_nbr}
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  textTransform: "uppercase",
                                                }}
                                              >
                                                {row.client_name}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {fmtMoney(
                                                  row.revised_net_premium
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                ${fmtMoney(row.policy_fee)}
                                              </TableCell>
                                              <TableCell>
                                                ${fmtMoney(row.iva)}
                                              </TableCell>
                                              <TableCell>
                                                ${fmtMoney(row.total)}
                                              </TableCell>
                                              <TableCell>
                                                ${fmtMoney(row.agency_fee)}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {fmtMoney(
                                                  row.total + row.agency_fee
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                {row.payment_name}
                                              </TableCell>
                                              <TableCell>
                                                {row.payment_created}
                                              </TableCell>
                                            </TableRow>
                                          );
                                        }
                                      )}
                                      <TableRow className="odd gradeX">
                                        <TableCell>&nbsp;</TableCell>
                                        <TableCell>
                                          <strong>
                                            Total{" "}
                                            {currentPaymentType ===
                                            "Customer Site"
                                              ? "Credit Card"
                                              : currentPaymentType}{" "}
                                            Sales:
                                          </strong>
                                        </TableCell>
                                        <TableCell>
                                          ${fmtMoney(subtotal.net)}
                                        </TableCell>
                                        <TableCell>
                                          ${fmtMoney(subtotal.policy)}
                                        </TableCell>
                                        <TableCell>
                                          ${fmtMoney(subtotal.iva)}
                                        </TableCell>
                                        <TableCell>
                                          ${fmtMoney(subtotal.total)}
                                        </TableCell>
                                        <TableCell>
                                          ${fmtMoney(subtotal.agency)}
                                        </TableCell>
                                        <TableCell>
                                          ${fmtMoney(subtotal.collected)}
                                        </TableCell>
                                        <TableCell>&nbsp;</TableCell>
                                      </TableRow>
                                    </React.Fragment>
                                  );
                                }
                              )}
                              <TableRow className="odd gradeX">
                                <TableCell colSpan={10}>&nbsp;</TableCell>
                              </TableRow>
                              <TableRow className="odd gradeX">
                                <TableCell></TableCell>
                                <TableCell>
                                  <strong>Total Charges Processed</strong>
                                </TableCell>
                                <TableCell>
                                  $
                                  {fmtMoney(
                                    (total["System Charged"]?.net || 0) +
                                      (total["Customer Site"]?.net || 0)
                                  )}
                                </TableCell>
                                <TableCell>
                                  $
                                  {fmtMoney(
                                    (total["System Charged"]?.policy || 0) +
                                      (total["Customer Site"]?.policy || 0)
                                  )}
                                </TableCell>
                                <TableCell>
                                  $
                                  {fmtMoney(
                                    (total["System Charged"]?.iva || 0) +
                                      (total["Customer Site"]?.iva || 0)
                                  )}
                                </TableCell>
                                <TableCell>
                                  $
                                  {fmtMoney(
                                    (total["System Charged"]?.total || 0) +
                                      (total["Customer Site"]?.total || 0)
                                  )}
                                </TableCell>
                                <TableCell>
                                  $
                                  {fmtMoney(
                                    (total["System Charged"]?.agency || 0) +
                                      (total["Customer Site"]?.agency || 0)
                                  )}
                                </TableCell>
                                <TableCell>
                                  $
                                  {fmtMoney(
                                    (total["System Charged"]?.collected || 0) +
                                      (total["Customer Site"]?.collected || 0)
                                  )}
                                </TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            </React.Fragment>
                          );
                        }
                      )}
                    <TableRow className="odd gradeX">
                      <TableCell colSpan={10}>&nbsp;</TableCell>
                    </TableRow>
                    <TableRow className="odd gradeX">
                      <TableCell></TableCell>
                      <TableCell>
                        <strong>Grand Total</strong>
                      </TableCell>
                      <TableCell>${fmtMoney(total_total.net)}</TableCell>
                      <TableCell>${fmtMoney(total_total.policy)}</TableCell>
                      <TableCell>${fmtMoney(total_total.iva)}</TableCell>
                      <TableCell>${fmtMoney(total_total.total)}</TableCell>
                      <TableCell>${fmtMoney(total_total.agency)}</TableCell>
                      <TableCell>${fmtMoney(total_total.collected)}</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Bottom Buttons */}
              <GridContainer style={{ marginTop: 16 }}>
                <GridItem xs={12} sm={6}>
                  &nbsp;
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(12, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(12, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
